<template>
    
    <div>
        <nav class="p-2 border-bottom border-primary">
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
             @click="mostraListaImpianti"
            >Lista Impianti</b-button>
            <b-button
            :pressed="true"
            class="typo-label"
            variant="link"
            >Lista Utenti in attesa validazione</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
             @click="mostraPaginaUtenti"
            >Lista Utenti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaCodiciPro"
            >Gestione Codici Pro</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'"
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraRiepilogo"
            >Riepilogo</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'" 
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraMappa"
            >Mappa</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'"
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraAldi"
            >Report Aldi</b-button>
        </nav>
        <Loader />
        <div v-if="!authorized && !pageloading" class="mt-4 center">
            <h3>Non sei autorizzato ad accedere a questa risorsa</h3>
        </div>
        <div v-if="!pageloading && authorized" class="animated fadeIn container-fluid">
            <b-row>
                <b-col md="10" offset-md="1" lg="6" offset-lg="3" class="py-4 text-center">
                    <b-form-group>
                        <b-input-group>
                        <!-- Attach Left button -->
                        <b-input-group-prepend>
                            <b-input-group-text>Cerca:</b-input-group-text>
                            
                        </b-input-group-prepend>
                        <b-form-input type="text" placeholder="" v-model="searchFilter"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary">
                                <i class="fa fa-search"></i>
                            </b-button>
                        </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col class="center">
                    <b-table id="ntoTable" :per-page="rpp" :current-page="tabPage" sticky-header="500px" 
                        :striped="true" :hover="true" :items="filteredList" :fields="tableFields" 
                        :outlined="true" >

                        <template v-slot:cell(address)="data">
                            <strong>{{data.value.city}} ({{data.value.prov}}) {{data.value.country}}</strong><br/>
                            {{data.value.cap}} -  {{data.value.street}} {{data.value.housenumber}}
                        </template>

                        <template v-slot:cell(phone)="{ item: item }">
                            tel: <strong>{{item.phone}} </strong><br/>
                            email: <strong>{{item.username}} </strong>
                        </template>
                        <template v-slot:cell(action)="{ item: item }">
                            <b-button variant="success" @click="validaUtente(item)">Valida</b-button> 
                            <b-button v-if="item.validation == 'pending'" variant="danger" @click="sospendiUtente(item)" style="margin-left: 20px">SOSPENDI</b-button>
                            <b-button v-if="item.validation == 'suspended'" variant="danger" @click="disattivaUtente(item)" style="margin-left: 20px">DISATTIVA</b-button>
                        </template>
                        
                    </b-table>
                </b-col>
            </b-row>
        </div>
    </div>


</template>

<script>

import { Auth } from 'aws-amplify'
import { API } from 'aws-amplify'
//import * as Axios from 'axios'

import { mapState, install } from 'vuex';


import router from '../router/approuter'
import {showAt, hideAt} from 'vue-breakpoints'


export default {
    name: 'NTOPendingUsers',
    components: {
        hideAt, showAt

    },    
    props: [],
    data() {
        return {
            userId: null,
            pageloading: true,
            searchFilter: "",
            authorized: false,
            dataLoaded: false,
            pendingUsers: [],
            tabPage: 1,
            rpp: 50,
            tableFields: [
                {
                    key: 'businessname',
                    label: 'Rag Soc',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true
                },
                {
                    key: 'surname',
                    label: 'Cognome',
                    sortable: true
                },
                {
                    key: 'address',
                    label: 'Indirizzo',
                    sortable: true
                },
                {
                    key: 'piva',
                    label: 'P.IVA',
                    sortable: true
                },
                {
                    key: 'phone',
                    label: 'Contatti',
                    sortable: false
                },
                {
                    key: 'action',
                    label: 'Azione',
                    sortable: false
                }
            ]
        }
    },
    created() {
        
    },
    mounted() {
        
            console.log("MOUNTED NTOPendingUsers " + this.pageloading);
        
            

            if (!this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
                //this.$store.dispatch('loadAllPlants',  this.$route.params.userId);
                const usertype = this.$store.getters.userType;
                console.log("ntpendingousers launch loadPendingUsers, " + usertype);
                if (usertype != 'admin') {
                    this.authorized = false;
                    this.pageloading = false;
                } else {
                    this.authorized = true;
                    this.pageloading = true; 
                    this.$store.dispatch('loadPendingUsers',  this.$store.state.user.username);
                }
            } 

        
    },
    updated() {
        if (this.userAllPlants==null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
           console.log("updated ntopendingusers");
        }
    },
    computed: {
         ...mapState(['loading']),
         filteredList() {
            var records = this.pendingUsers;
            if (this.searchFilter != '') records = this.pendingUsers.filter(user => {
            return (user.businessname.toLowerCase().includes(this.searchFilter.toLowerCase()) 
                    || user.address.street.toLowerCase().includes(this.searchFilter.toLowerCase())
                    || user.address.city.toLowerCase().includes(this.searchFilter.toLowerCase())
                    || user.address.prov.toLowerCase().includes(this.searchFilter.toLowerCase())
                    || user.address.country.toLowerCase().includes(this.searchFilter.toLowerCase())
                    || user.name.toLowerCase().includes(this.searchFilter.toLowerCase())
                    || user.surname.toLowerCase().includes(this.searchFilter.toLowerCase())
                    || user.phone.toLowerCase().includes(this.searchFilter.toLowerCase())
                    || user.piva.toLowerCase().includes(this.searchFilter.toLowerCase())
                    || user.username.toLowerCase().includes(this.searchFilter.toLowerCase())
                    )
            });
            return records.map(user => {
                if (user.validation == 'suspended') user["_rowVariant"] = 'warning';
                return user;
            });
        }
    },  
     watch: {
        loading(val,oldval) {
            console.log("loading changed:" + val+", dataloaded="+this.dataLoaded);
            if (val == false) {
                if (this.dataLoaded) {
                    const usertype = this.$store.getters.userType;
                    console.log("ntopendingusers launch loadPendingUsers, " + usertype);
                    this.dataLoaded = false;
                    this.pageloading = true;
                    if (usertype != 'admin') {
                        this.authorized = false;
                        this.pageloading = false;
                    } else {
                        this.authorized = true;
                        this.pageloading = true; 
                        this.$store.dispatch('loadPendingUsers',  this.$store.state.user.username);
                    }
                } else {
                    if (!this.authorized) {
                        if (this.$store.getters.userType == 'admin')  {
                            this.authorized = true;
                            this.pageloading = true;
                            this.$store.dispatch('loadPendingUsers',  this.$store.state.user.username);
                            return;
                        }
                    }
                    this.pendingUsers = this.$store.state.pendingUsers;
                    this.dataLoaded = true;
                    this.pageloading = false;
                }
                
            }
        }
     },        
    methods: {
        mostraListaImpianti() {
            router.push({ name: 'NTOHome'})
        },
        mostraPaginaUtenti() {
            router.push({ name: 'NTOUsers'})
        },
        mostraPaginaCodiciPro() {
            router.push({ name: 'NTOProCodes'})
        },        
        mostraRiepilogo() {
            router.push({ name: 'NTOSummary'})
        },
        mostraMappa() {
            router.push({ name: 'NTOPlantsMap'})
        },
        mostraAldi() {
            router.push({ name: 'NTOAldi'})
        },

        validaUtente(user) {
            
            let self = this;
            let callerId = (this.$store.state.user.attributes["custom:iduser"] != null) ? this.$store.state.user.attributes["custom:iduser"] : this.$store.state.user.attributes.sub;
            console.log("valido ", user, this.$store.state.user, callerId);
            this.$bvModal.msgBoxConfirm("Confermi  la validazione come Installatore per l'utente " + user.name + " " + user.surname + ", ditta " + user.businessname + "?", {
                        title: 'Conferma validazione utente',
                        okVariant: 'success',
                        okTitle: 'Valida',
                        cancelTitle: 'CHIUDI',
                        centered: true
                    }).then((value) => {
                        if (value == true) {
                            self.$store.dispatch('updateUserValidation', {callerId: callerId, userId: user.id, validationStatus: 'validated'});
                        }
                    });



        },
        sospendiUtente(user) {
            
            let self = this;
            let callerId = (this.$store.state.user.attributes["custom:iduser"] != null) ? this.$store.state.user.attributes["custom:iduser"] : this.$store.state.user.attributes.sub;
            console.log("sospendo ", user, this.$store.state.user, callerId);
            this.$bvModal.msgBoxConfirm("Confermi la SOSPENSIONE per l'utente " + user.name + " " + user.surname + ", ditta " + user.businessname + "?\n\nL'utente non potrà accedere al sistema finchè non sarà Disattivato o Validato.\n\nContattare l'utente per chiarire il motivo della sospensione.", {
                title: 'Conferma SOSPENSIONE utente',
                okVariant: 'danger',
                okTitle: 'Sospendi',
                cancelTitle: 'CHIUDI',
                centered: true
            }).then((value) => {
                if (value == true) {
                    self.$store.dispatch('updateUserValidation', {callerId: callerId, userId: user.id, validationStatus: 'suspended'});
                }
            });



        },
        disattivaUtente(user) {
            
            let self = this;
            let callerId = (this.$store.state.user.attributes["custom:iduser"] != null) ? this.$store.state.user.attributes["custom:iduser"] : this.$store.state.user.attributes.sub;
            console.log("disattivo ", user, this.$store.state.user, callerId);
            this.$bvModal.msgBoxConfirm("Confermi la DISATTIVAZIONE per l'utente " + user.name + " " + user.surname + ", ditta " + user.businessname + "?\n\nL'utente non potrà più accedere al sistema!!", {
                title: 'Conferma SOSPENSIONE utente',
                okVariant: 'danger',
                okTitle: 'Disattiva',
                cancelTitle: 'CHIUDI',
                centered: true
            }).then((value) => {
                if (value == true) {
                    self.$store.dispatch('updateUserValidation', {callerId: callerId, userId: user.id, validationStatus: 'disabled'});
                }
            });



        }
    }

}
</script>

<style lang="scss" scoped>
    .bottomNav {
        bottom:60px;
        //background-color: #fff;
    }
    .totLabel {
        font-family: 'Roboto',sans-serif;
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    

</style>